import React from "react";
import ReactDOM from 'react-dom';
import L, {divIcon} from "leaflet";
import {Marker, Popup, Tooltip} from "react-leaflet";
import PropTypes from "prop-types";
import {withNamespaces} from "react-i18next";
import styles from "./RouteMapPoint.scss";
import MapPopup from "../MapPopup";
import {getIconData} from "./RouteMapPoint.bl";
import NODE_TYPES from "../../constants/nodeTypes";
import {getAddressParts} from "../../utils/addressHelper";

/**
 * @param icon
 * @param {RouteResponsePoint} routePoint
 * @param passthroughIndex
 * @param t
 * @param handleRemoveIntermediateCity
 */
const createPassthroughCityIcon = (icon, routePoint, passthroughIndex, t, handleRemoveIntermediateCity) => {
  const buttonTooltip = t("trace-map-point-remove-passthrough-node-tooltip", "Удалить точку");
  
  const excludeButton = <button type="button" className={styles.exclude}
                                onClick={() => handleRemoveIntermediateCity(passthroughIndex)}
                                title={buttonTooltip}>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14">
      <path
        d="M8.637.988h2.601V2.5H.762V.988h2.601L4.137.25h3.726l.774.738zM3.328 6.895l1.617 1.617-1.582 1.582 1.055 1.054L6 9.566l1.582 1.582 1.055-1.054-1.582-1.582 1.582-1.617L7.582 5.84 6 7.457 4.418 5.84l-1.09 1.055zM1.5 12.238v-9h9v9c0 .399-.152.75-.457 1.055-.305.305-.656.457-1.055.457H3.012c-.399 0-.75-.152-1.055-.457-.305-.305-.457-.656-.457-1.055z"/>
    </svg>
  </button>;
  
  const div = document.createElement('div');
  const container = <div className={styles.intermediate}>
    <div className={styles.marker}>
      <div className={styles.content}>
        <div className={styles.index}>{passthroughIndex + 1}</div>
        {excludeButton}
      </div>
    </div>
  </div>;
  
  // Рендерим React компонент в div
  ReactDOM.render(container, div);
  
  return divIcon({
    className: "my-div-icon",
    html: div,
    iconAnchor: icon.iconAnchor,
    iconSize: icon.size,
  });
};

const createImageIcon = icon =>
    L.icon({
      iconUrl: icon.path,
      iconSize: icon.size,
      iconAnchor: icon.iconAnchor,
    });

class RouteMapPoint extends React.Component {
  render() {
    const {
      visitedRoutePoint,
      showPopup,
      markerRef,
      t,
      i18n: {language}
    } = this.props;
   
    /** @type {RouteResponsePoint} */
    const routePoint = visitedRoutePoint.routePoint;
    const visits = visitedRoutePoint.visits;
    const position = L.latLng(routePoint.geoPoint.lat, routePoint.geoPoint.lon);

    const iconData = getIconData(visitedRoutePoint, language);
    const icon = visits.length === 1 && (visits[0].nodeTypes & NODE_TYPES.passthrough) !== 0 
        ? createPassthroughCityIcon(iconData, routePoint, visits[0].passthroughIndex, t, this.props.excludePassthroughPoint) 
        : createImageIcon(iconData);
    
    const addressParts = getAddressParts(routePoint);
    const name = addressParts[0];
    const clarifyParts = addressParts[1];
    
    return (
      <Marker position={position} draggable={false} icon={icon} zIndexOffset={1000} ref={markerRef}>
        {showPopup && (
          <Popup className={styles.popup} autoPan={false}>
            <MapPopup visitedRoutePoint={visitedRoutePoint}/>
          </Popup>
        )}
        {!L.Browser.mobile && (
          <Tooltip direction="bottom" opacity={1.0}>

            <div className={styles.tooltipText}>
              <div className={styles.tooltipHeader}>
                {name}
              </div>
              {clarifyParts && (<div className={styles.tooltipFooter}>
                {clarifyParts}
              </div>)}
            </div>
          </Tooltip>
        )}
      </Marker>
    );
  }
}

RouteMapPoint.defaultProps = {
  cityNumber: 0,
  showPopup: true,
  markerRef: undefined
};

RouteMapPoint.propTypes = {
  visitedRoutePoint: PropTypes.shape({
    routePoint: PropTypes.shape({
      nodeTypes: PropTypes.number.isRequired,
      geoPoint: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
      }).isRequired
    }).isRequired,
    visits: PropTypes.array.isRequired
  }),
  t: PropTypes.func.isRequired,
  showPopup: PropTypes.bool,
  markerRef: PropTypes.shape(),
  excludePassthroughPoint: PropTypes.func.isRequired
};

export default withNamespaces()(RouteMapPoint);
